﻿$.fn.dxCtrlTooltipHoverTarget = function custom_dxCtrlTooltipHoverTarget(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrltooltiphovertarget dx-ctrl");
        this.createInstance(new cdxCtrlTooltipHoverTarget(this, option));
    }
    return this;
}

window.cdxCtrlTooltipHoverTarget = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dx = null;
    var timerHide = null;
    var timerShow = null;
    var parent = null;
    this.allowShow = true
    function mConstruit() {
        parent = container.parent();
        container.remove();

        var hidden = option.onHidden;
        option.onHidden = function (e) {
            if (typeof hidden != 'undefined') hidden(e)
            container.remove();
            dx = null;
        }
        option.showCloseButton = false;
        var contentTemplate = option.contentTemplate;
        option.contentTemplate = function (contentElement) {
            contentElement.css("white-space", "normal");
            if (typeof contentTemplate != 'undefined') contentTemplate(contentElement)
        }
        var hiding = option.onHiding;
        option.onHiding = function (e) {
            window.clearTimeout(timerShow);
            if (typeof hiding != 'undefined') hiding(e);
            lstEventMouseMove.splice(lstEventMouseMove.indexOf(dx.fnMouseMove), 1)
            dx = null;
        }

        Me.isDisabled(false)
    }

    this.show = function () { if (dx) dx.show(); }
    this.hide = function () { if (dx) dx.hide(); }
    var isIn = false

    this.remove = function () {
        option.target.off("x.mouseenter")
        option.target.off("x.pointerleave")
    }
    this.isDisabled = function (disabled) {
        if (disabled) {
            if (dx) dx.hide()
            option.target.off("x.mouseenter")
            option.target.off("x.pointerleave")
        } else {
            option.target.off("x.mouseenter")
            option.target.on("x.mouseenter", function (e) {
                isIn=true
                //on affiche pas les tooltip sur téléphone ou tablette
                if (DevExpress.devices.current().deviceType == "phone" || DevExpress.devices.current().deviceType == "tablet") return
                window.clearTimeout(timerHide);
                window.clearTimeout(timerShow);
                timerShow = window.setTimeout(function () {
                    if (!isIn) return;
                    if (!Me.allowShow) return;
                    if (!dx) {
                        container = $("<div class='dx-ctrltooltiphovertarget dx-ctrl'/>").appendTo(parent)
                        dx = container.dxCtrlTooltip(option).dxCtrlTooltip("instance")
                        var fnMouseMove = lstEventMouseMove.push(function () {
                            window.clearTimeout(timerHide);
                            //console.log("fnmove");
                            timerHide = window.setTimeout(function () {
                                if (dx && !mCursorIsIn(option.target, "target")) {
                                    dx.hide();
                                }
                            }, 10)
                        });
                        dx.fnMouseMove = lstEventMouseMove[fnMouseMove - 1];
                    }
                    if (typeof option.onShowing != 'undefined') option.onShowing();
                    dx.show();
                }, 100);
            })
            option.target.off("x.pointerleave")
            option.target.on("x.pointerleave", function (e) {
                console.log("out")
                isIn=false
                window.clearTimeout(timerShow);
            });
        }
    }


    mConstruit();
}